import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from '@mui/material';
import { BASE_ADMIN_API_URL } from '../../../../config';
import { useFetch } from '../../../../hooks/use-fetch';

export const useMovementLoadListAction = (sn) => {
    const fetch = useFetch();
    return useCallback(async () => {
        try {
            const response = await fetch(
                `${BASE_ADMIN_API_URL}/actions/devices/${sn}/movements/list/`,
                {
                    method: 'GET',
                });

            if (!response.ok) {
                throw new Error(await response.text());
            }
        } catch (e) {
            console.error(e);
        }

    }, []);
}

export default function MovementsLoadListIconButton({ sn }) {
    const action = useMovementLoadListAction(sn);

    return (
        <IconButton onClick={action} aria-label="refresh movements">
            <RefreshIcon />
        </IconButton>
    )
}

MovementsLoadListIconButton.propTypes = {
    sn: PropTypes.string
}
